import { type Translate } from 'next-translate'
import { toast } from 'react-toastify'

class Toaster {
  t: any

  setTranslator = (t: Translate) => {
    this.t = t
  }

  error = (error: string, params: Record<string, string | number> = {}): void => {
    toast.error(this.t(error, params, { fallback: 'errors.defaultError' }))
    return
  }

  warning = (warning: string): void => {
    toast.warn(this.t(warning))
  }

  info = (message: string, params: Record<string, string | number> = {}): void => {
    toast.info(this.t(message, params))
  }

  success = (message: string, params: Record<string, string | number> = {}): void => {
    toast.success(this.t(message, params))
  }

  defaultMessage = (message: string): void => {
    toast(this.t(message))
  }
}

export default new Toaster()
